// Public reader route. Fetches { doc, glossary } from /docs/:docId/render
// and hands the payload to ReadingPage. The unit-test layer can still use
// useFixtureDoc directly by passing it in; this route uses the live API.

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { useLiveDoc } from "../data/api";
import { ReadingPage } from "../render/ReadingPage";

export const docsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/docs/$docId",
  component: DocsPage,
});

function DocsPage() {
  const { docId } = docsRoute.useParams();
  const query = useLiveDoc(docId);

  if (query.isPending) return <div className="maisight-loading">Loading…</div>;
  if (query.isError) {
    return (
      <div className="maisight-error" role="alert">
        Could not load document: {query.error.message}
      </div>
    );
  }
  const { doc, glossary, config, equations, corpus_glossary } = query.data;
  // Backend ships equations as `{equations: [...]}` to keep ETag stable
  // against versions.json — unwrap to the array the renderer consumes.
  const equationsArray =
    equations && "equations" in equations ? equations.equations : undefined;
  return (
    <ReadingPage
      doc={doc}
      glossary={glossary}
      config={config}
      equations={equationsArray}
      corpusGlossary={corpus_glossary ?? null}
    />
  );
}
